import { Modal } from "d-react-components";
import { useFormik } from "formik";
import React from "react";
import Messages from "../../../languages/Messages";
import OrderFilterForm from "./OrderFilterForm";

interface IOrderTableFilterModal {
    open: boolean;
    defaultValue: any;
    onClose: () => void;
    onFilter: (values: any) => void;
}

function OrderFilterModal({
    open,
    defaultValue = {},
    onClose,
    onFilter,
}: IOrderTableFilterModal) {
    const filterForm = useFormik<any>({
        initialValues: defaultValue as any,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values: any) => {
            onFilter(values);
            onClose();
        },
    });

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={Messages.filter}
            onSave={() => filterForm.handleSubmit()}
            size="medium"
            sideText={Messages.clearAll}
            onSideClick={() => filterForm.setValues({})}
        >
            <OrderFilterForm formData={filterForm} />
        </Modal>
    );
}

export default OrderFilterModal;
